import React from "react";
import { HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import Reveal from "./Reveal";
import { personal } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function Contact({ cvHref }) {
    const { t } = useLanguage();
    const contactText = t.contact.text.replace("{location}", t.about.location);

    return (
        <section id="contact" className="section section--contact">
            <div className="section__inner">
                <Reveal className="contact-card">
                    <span className="section-eyebrow">{t.contact.eyebrow}</span>
                    <h2 className="contact-card__title">{t.contact.title}</h2>
                    <p className="contact-card__text">{contactText}</p>
                    <div className="hero__actions contact-card__actions">
                        <a className="btn btn--primary" href={`mailto:${personal.email}`}>
                            <HiOutlineMail /> {t.contact.emailMe}
                        </a>
                        <a className="btn btn--ghost" href={`tel:${personal.phone}`}>
                            <HiOutlinePhone /> {t.contact.callMe}
                        </a>
                        <a className="btn btn--ghost" href={cvHref} target="_blank" rel="noreferrer">
                            {t.contact.downloadCV}
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
